import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import Translate from 'react-translate-component';
import cx from 'classnames';
import { Tooltip } from 'antd';

import { getScenario, postScenarioTest, putScenarioBookRead } from 'actions/asyncActions';
import { notEmpty } from 'utils/ramdaAdditions';
import StaticTable from 'components/common/tableComponents/StaticTable';
import RefreshButton from 'components/common/controls/RefreshButton';
import { TestComponent } from './TestComponent';
import { setHeaderTitle } from 'actions/appActions';
import { openModalScenario } from 'actions/modalActions';
import * as testTypes from 'constants/scenarioTestTypes';
import CustomIcon from 'components/common/CustomIcon';

const TITLES = {
    36434: 'menu.remoteCourse',
    36433: 'menu.remoteAssesment'
};

const TYPES = {
    [testTypes.ONLINE_TEST]: <Translate content="education.scenario.test" />,
    [testTypes.LIBRARY_OBJ]: '',
    [testTypes.SCORM_TEST]: <Translate content="education.scenario.scormTest" />,
    [testTypes.LIBRARY_OBJ_BOOK]: <Translate content="education.scenario.book" />,
    [testTypes.LIBRARY_OBJ_DOC]: <Translate content="education.scenario.doc" />,
    [testTypes.DISTANCE_TRAINING]: <Translate content="education.scenario.training" />,
};

const getType = ({ type = testTypes.LIBRARY_OBJ }) => {
    return TYPES[type] || null;
};

@asyncConnect({
    getScenario: getScenario
        .withPayload(({ params: { objkey, cmd, objtype } }) => ({ objkey, cmd, objtype }))
        .withOptions({ dispatchOnMount: true, resetOnUnmount: true })
        .withSuccessHandler(({ setHeaderTitle, getScenario: { data: { object = {}, type } } }) =>
            setHeaderTitle({ title: TITLES[type] || 'education.scenario.name', params: { name: object.name } })
        ),
    postScenarioTest: postScenarioTest
        .withSuccessHandler(({ getScenario }) => {
            getScenario.refresh();
        }),
    putScenarioBookRead: putScenarioBookRead
        .withSuccessHandler(({ getScenario: { refresh } }) => refresh())
}, null, { setHeaderTitle, openModalScenario })
export default class Scenario extends Component {
    static propTypes = {
        getScenario: PropTypes.object.isRequired,
        params: PropTypes.shape({
            objkey: PropTypes.number.isRequired,
            cmd: PropTypes.string.isRequired,
            objtype: PropTypes.string.isRequired,
            token: PropTypes.string,
        }),
        setHeaderTitle: PropTypes.func.isRequired,
        openModalScenario: PropTypes.func.isRequired
    }

    tableColumns = [
        {
            name: 'stageName',
            additionalClass: 'p-l-15',
            label: <Translate content="education.scenario.stageName" />,
            template: ({ item }) => <span className={cx({'p-l-25': item.parentId !== 0 })}>{item.name}</span>,
            width: 200
        },
        {
            name: 'tests',
            label: '',
            template: ({ item }) => notEmpty(item.stageList) && (
                <ul>
                    { item.stageList.map((stageItem, index) => (
                        <li key={index}>
                            <TestComponent
                                token={this.props.params.token}
                                stageItem={stageItem}
                                scenarioParams={this.props.params}
                            />
                        </li>
                    )) }
                </ul>
            ),
            width: 550
        },
        {
            name: 'type',
            label: <Translate content="education.scenario.type" />,
            template: ({ item }) => notEmpty(item.stageList) && (
                <ul className="scenario-tests">
                    { item.stageList.map((stageItem, index) => (
                        <li key={index}>
                            { getType(stageItem) }
                        </li>
                    )) }
                </ul>
            ),
            width: 250
        },
        {
            name: 'states',
            label: <Translate content="education.scenario.states" />,
            template: ({ item }) => notEmpty(item.stageList) && (
                <ul>
                    { item.stageList.map((stageItem, index) => (
                        <li key={index}>
                            <Translate content={`education.scenario.state.${stageItem.state}`} className="m-r-8" />
                        </li>
                    )) }
                </ul>
            ),
            width: 250
        }
    ]

    render() {
        const { data: { stages = [] }, meta, refresh } = this.props.getScenario;

        return (
            <div className="scenario">
                <div className="clearfix">
                    <RefreshButton className="scenario-button" refreshMeta={meta} handleRefresh={refresh} />
                    <a className="scenario-button" onClick={this.props.openModalScenario}>
                        <CustomIcon type='info-outline' />
                    </a>
                    <Tooltip title={<Translate content="education.scenario.forNextStage" />} placement="bottomRight">
                        <span className="scenario-button">
                            <CustomIcon type="info" />
                        </span>
                    </Tooltip>
                </div>
                <div className="scenario-body">
                    <StaticTable
                        meta={meta}
                        refresh={refresh}
                        columns={this.tableColumns}
                        items={stages}
                    />
                </div>
            </div>
        );
    }
}
